import React, { useEffect, useState } from 'react';
import Logo from "../../utilities/Logo";
import { Box, Flex, Text } from "@chakra-ui/layout";
import { Button, Stack } from "@chakra-ui/react";
import Courses from "../../utilities/Courses";
import { StateType, useStudentAuthDispatch } from "../../../store/store";
import { courseRegister, getCourses } from "../../../action/studentAction";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from 'react-router-dom';

export type structure = {
  course_id: string,
  course_name: string,
  course_description: string,
  lecture_days: string,
  lecture_hours: string
}

function CourseRegistration() {
  const dispatch = useStudentAuthDispatch();
  const { courses: { courses }, data: { user_id, token } } = useSelector((state: StateType) => state.rootReducer.studentReducer);
  const userToken = token.includes("Bearer") ? token.slice(17, (token.length - 2)) : token.slice(10, (token.length - 2));
  let history = useHistory();

  const [checkedState, setCheckedState] = useState<boolean[]>(
    new Array(courses.length).fill(false)
  );

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const array: structure[] = [];
    checkedState.map((item, index) => {
      if (item) {
        //console.log(courses[index])
        array.push(courses[index]);
      }
    })
    console.log("continue clicked");
    //console.log(array);
    if (array.length < 1) {
      return await Swal.fire({
        icon: "error",
        text: "You must select a course"
      })
    }
    const studentId = user_id;
    if (array.length > 1) {
      for (let x in array) {
        let courseId = array[x].course_id;
        await dispatch(courseRegister({ courseId, studentId }, userToken))
      }
      return;
    }
    const courseId = array[0].course_id;
    const courseData = { courseId, studentId }
    await dispatch(courseRegister(courseData, userToken))
  }

  function goBack() {
    history.goBack();
  }

  useEffect(() => {
    dispatch(getCourses(userToken));
  }, [])

  return (
    <Box>
      <Logo _fontSize={"3rem"} _mt={8} />
      <Flex direction={"column"} justifyContent={"center"} alignItems={"center"} mt={10}>
        <Text fontWeight={"semibold"} fontSize={"md"} textAlign={"left"}>Select courses/ subjects</Text>
        <form onSubmit={(e) => handleSubmit(e)}>
          <Stack spacing={4} mt={4} direction="row" wrap={"wrap"} justifyContent={"center"} alignItems={"center"}>
            {
              courses.map((course: structure, index: number) => <Courses key={index} checkedState={checkedState}
                setCheckedState={setCheckedState}
                courseName={course.course_name}
                index={index} courses={courses} />)
            }
          </Stack>
          <Flex flexDirection="column" justifyContent={"center"} alignItems={"center"}>
            <Button type={"submit"} size="lg" textTransform={"capitalize"} fontSize={16} bgColor={"brand.darkGreen"}
              color={"brand.white"} mt={12}
              display={"block"} hover={{ backgroundColor: "green.600" }}
              w={"clamp(150px, 80vw, 400px)"}>continue
            </Button>
            <Button bgColor={"red.500"} color={"brand.white"} mt={5} onClick={() => goBack()}>
              Go Back
            </Button>
          </Flex>

        </form>
      </Flex>
    </Box>
  );
}

export default CourseRegistration;